import { Controller } from "@hotwired/stimulus"

// Keeps a form's submit button disabled until the guarded field has a value.
//
// The copy/move dialogs open on an empty "Select a folder…" option, and Tom
// Select lets you clear back to it. Submitting with no folder selected is a
// silent no-op — the server returns 422 and nothing visibly happens (#2583).
// Holding the button disabled until a real folder is chosen makes that dead
// click impossible.
export default class extends Controller {
  static targets = ["field", "submit"]

  connect() {
    this.refresh()
  }

  refresh() {
    this.submitTarget.disabled = this.fieldTarget.value === ""
  }
}
